import { resource, RequestConfig } from '../helper/resource';

/**
 * 机构客户获取授权人名单
 */
export function trustServer_authorizerUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListAuthorizerDto> {
  return resource.post('/lcTrust/client/authorizer', req, config);
}

/**
 * 个人/机构/产品购买信托-客户是否需要双录
 */
export function trustServer_doubleRecordingXtUsingPOST(
  req: TrustServer.ClientRecordParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lcTrust/client/doubleRecordingXt', req, config);
}

/**
 * 获取鉴权流水号
 */
export function trustServer_getAuthSerialNoUsingPOST(
  req: TrustServer.Athorizer | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrust/client/getAuthSerialNo', req, config);
}

/**
 * 获取人脸识别结果
 */
export function trustServer_identifiedResultUsingPOST(
  req: TrustServer.EncodeTokenParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lcTrust/client/identifiedResult', req, config);
}

/**
 * 个人购买权限校验
 */
export function trustServer_checkPersonPermissionUsingPOST(
  req: TrustServer.ProductionParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrust/client/permission', req, config);
}

/**
 * 查询客户是否回访
 */
export function trustServer_getRevisitUsingPOST(
  req: TrustServer.AllotnoParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultTrustRevisit> {
  return resource.post('/lcTrust/client/queryRevisit', req, config);
}

/**
 * 注册Token
 */
export function trustServer_registerUsingPOST(
  req: TrustServer.IdentificationParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListstring> {
  return resource.post('/lcTrust/client/register', req, config);
}

/**
 * 客户回访
 */
export function trustServer_trustRevisitUsingPOST(
  req: TrustServer.TrustRevisitParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrust/client/revisit', req, config);
}

/**
 * 获取Token
 */
export function trustServer_getTokenUsingPOST(
  req: TrustServer.ProductionParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultFlowNoAndTokenDto> {
  return resource.post('/lcTrust/client/token', req, config);
}

/**
 * 是否合格资管投资者
 */
export function trustServer_checkVerifiedUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lcTrust/client/verified', req, config);
}

/**
 * 机构购买权限校验
 */
export function trustServer_checkInstitutePermissionUsingPOST(
  req: TrustServer.ProductionParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrust/institute/permission', req, config);
}

/**
 * 获取产品公告信息
 */
export function trustServer_queryAnnouncementUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListAnnouncementDto> {
  return resource.post('/lcTrust/queryAnnouncement', req, config);
}

/**
 * 获取集合信托详情
 */
export function trustServer_trustQueryDetailInfoUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultLcTrustInfoDto> {
  return resource.post('/lcTrust/queryDetailInfo', req, config);
}

/**
 * 获取历史规模
 */
export function trustServer_queryHisScaleTrendUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListLcTrustScaleDto> {
  return resource.post('/lcTrust/queryHisScaleTrend', req, config);
}

/**
 * 获取净值走势
 */
export function trustServer_queryNetValueTrendUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultNetValueTrendDto> {
  return resource.post('/lcTrust/queryNetValueTrend', req, config);
}

/**
 * 获取各周期收益率
 */
export function trustServer_queryPeriodYieldUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultFixedPeriodYieldDto> {
  return resource.post('/lcTrust/queryPeriodYield', req, config);
}

/**
 * 获取客户购买的信托产品信息
 */
export function trustServer_queryProductUsingPOST(
  req: TrustServer.QueryProductParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListQueryProductInfoDto> {
  return resource.post('/lcTrust/queryProduct', req, config);
}

/**
 * 获取收益率走势
 */
export function trustServer_queryYieldTrendUsingPOST(
  req: TrustServer.LcTrustInfoDetailParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultYieldTrendDto> {
  return resource.post('/lcTrust/queryYieldTrend', req, config);
}

/**
 * 个人/机构户批量签署协议
 */
export function trustServer_batchSignUsingPOST(
  req: TrustServer.SignParam | void,
  config?: RequestConfig
): Promise<boolean> {
  return resource.post('/lcTrustContract/batchSign', req, config);
}

/**
 * 获取客户待签署合同列表
 */
export function trustServer_agreementListUsingPOST(
  req: TrustServer.AgreementListParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListAgreementListDto> {
  return resource.post('/lcTrustContract/client/agreementList', req, config);
}

/**
 * 客户已购买的产品号
 */
export function trustServer_getBoughtProdUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListstring> {
  return resource.post('/lcTrustContract/client/boughtProd', req, config);
}

/**
 * 获取客户合同
 */
export function trustServer_contractUsingPOST(
  req: TrustServer.ClientContractParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultAgreementListDto> {
  return resource.post('/lcTrustContract/client/contract', req, config);
}

/**
 * 创建个人客户签章
 */
export function trustServer_createPersonSealUsingPOST(
  req: TrustServer.CreateSealParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultJSONObject> {
  return resource.post('/lcTrustContract/client/creatSeal', req, config);
}

/**
 * 查询客户是否第一次购买
 */
export function trustServer_isFirstUsingPOST(
  req: TrustServer.IsFirstParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultIsFirstDto> {
  return resource.post('/lcTrustContract/client/isFirst', req, config);
}

/**
 * 获取客户签章
 */
export function trustServer_getSealUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultJSONObject> {
  return resource.post('/lcTrustContract/client/seal', req, config);
}

/**
 * 记录双录成功的客户
 */
export function trustServer_videoOkUsingPOST(
  req: TrustServer.VideoOkParam | void,
  config?: RequestConfig
): Promise<void> {
  return resource.post('/lcTrustContract/client/videoOk', req, config);
}

/**
 * 双录是否有效
 */
export function trustServer_hasVideoRecordUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrustContract/client/videoRecord', req, config);
}

/**
 * 获取条款
 */
export function trustServer_getClauseUsingPOST(
  req: TrustServer.ContractParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListContractClauseDto> {
  return resource.post('/lcTrustContract/contract/clause', req, config);
}

/**
 * 获取产品合同
 */
export function trustServer_getContractListUsingPOST(
  req: TrustServer.ProductionParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListstring> {
  return resource.post('/lcTrustContract/contract/list', req, config);
}

/**
 * 条款留痕
 */
export function trustServer_confirmClauseUsingPOST(
  req: TrustServer.ClauseParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrustContract/contract/updateClause', req, config);
}

/**
 * 获取抄录内容
 */
export function trustServer_getCopyUsingPOST(
  req: TrustServer.ClientContractParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultstring> {
  return resource.post('/lcTrustContract/getCopy', req, config);
}

/**
 * 获取客户待签署合同列表的状态
 */
export function trustServer_getSignedStateUsingPOST(
  req: TrustServer.AgreementListParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListClientContract> {
  return resource.post('/lcTrustContract/getSignedState', req, config);
}

/**
 * 阅读留痕
 */
export function trustServer_readSaveUsingPOST(
  req: TrustServer.ReadLeaveDto | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lcTrustContract/readSave', req, config);
}

/**
 * 查询所需信息
 */
export function trustServer_specialUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultMapstringstring> {
  return resource.post('/lcTrustContract/risk/clientInfo', req, config);
}

/**
 * 获取产品合同列表
 */
export function trustServer_signListUsingPOST(
  req: TrustServer.AgreementListParam | void,
  config?: RequestConfig
): Promise<TrustServer.ApiResultListClientContract> {
  return resource.post('/lcTrustContract/signList', req, config);
}

/**
 * 测试下载
 */
export function trustServer_testUsingPOST_1(req: FormData, config?: RequestConfig): Promise<Array<string>> {
  return resource.postForm('/lcTrustContract/test', req, config);
}

/**
 * 测试创建签章
 */
export function trustServer_testSealUsingPOST(req: FormData, config?: RequestConfig): Promise<Array<string>> {
  return resource.postForm('/lcTrustContract/testSeal', req, config);
}

/**
 * 测试签署
 */
export function trustServer_testUsingPOST(req: FormData, config?: RequestConfig): Promise<Array<string>> {
  return resource.postForm('/lcTrustContract/testSign', req, config);
}

/**
 * 更新一键抄录状态
 */
export function trustServer_updateTranscriptionStatusUsingPOST(
  req: TrustServer.UpdateTranscriptionStatusDto,
  config?: RequestConfig
): Promise<TrustServer.ApiResultboolean> {
  return resource.post('/lcTrustContract/updateTranscriptionStatus', req, config);
}
